import React from 'react';
import Alert from '@mui/material/Alert';
import { ReactComponent as AlertTriangleIcon } from 'v2/icons/alert-triangle-icon.svg';
import styles from './AlertError.module.scss';

type AlertErrorProps = {
  message: string;
};

export default function AlertError({ message }: AlertErrorProps) {
  return (
    <Alert
      severity="error"
      icon={<AlertTriangleIcon color="var(--danger-dark4)" />}
      className={styles.fadeInAnimation}
    >
      <strong
        style={{
          color: 'var(--danger-dark4)',
        }}
      >
        {message}
      </strong>
    </Alert>
  );
}
